const CARD_ACCENT_COLORS = [
    // Full cycle of brand colors, shared by every section-color consumer (accent bars, table columns).
    'bg-primary-beet',
    'bg-primary-raspberry',
    'bg-primary-plum',
    'bg-primary-carrot',
    'bg-primary-avocado',
    'bg-primary-lime',
    'bg-primary-blueberry',
    'bg-primary-acai',
];

const CARD_HEADER_BG_COLORS = [
    // Same brand cycle as CARD_ACCENT_COLORS, at the -50 shade for table header rows.
    // Raspberry and acai use -100: their -50 is too close to white to read as tinted.
    'bg-primary-beet-50',
    'bg-primary-raspberry-100',
    'bg-primary-plum-50',
    'bg-primary-carrot-50',
    'bg-primary-avocado-50',
    'bg-primary-lime-50',
    'bg-primary-blueberry-50',
    'bg-primary-acai-100',
];

function pickFromCycle(colors: string[], sectionIndex: number) {
    return colors[sectionIndex % colors.length];
}

export function useSectionColor() {
    function getCardAccentColor(sectionIndex: number) {
        return pickFromCycle(CARD_ACCENT_COLORS, sectionIndex);
    }

    function getCardHeaderBgColor(sectionIndex: number) {
        return pickFromCycle(CARD_HEADER_BG_COLORS, sectionIndex);
    }

    return { getCardAccentColor, getCardHeaderBgColor };
}
